import React from 'react';
import { Form, Field } from '@cloudhub-ux/core/form';
import CheckBox from '@cloudhub-ux/core/CheckBox';
import RemoteSelector from '@cloudhub-ux/core/selectors/RemoteSelector';
import Block from '@cloudhub-ux/core/Block';
import Popper from '@mui/material/Popper';
import Input from '@cloudhub-ux/core/Input';
import Button from '@cloudhub-ux/core/Button';
import Divider from '@cloudhub-ux/core/Divider';
// import { makeStyles } from '@mui/material/styles';
import useAdminAxios from 'admin/context/useAdminAxios';
import ClickAwayListener from '@mui/material/ClickAwayListener';

// const useStyles = makeStyles((theme) => ({
//   popper: {
//     zIndex: theme.zIndex.modal,
//   },
//   paper: {
//     padding: theme.spacing(2),
//     minWidth: 300,
//   },
//   divider: {
//     margin: theme.spacing(2, 0),
//   },
//   buttonGroup: {
//     display: 'flex',
//     justifyContent: 'space-between',
//     marginTop: theme.spacing(2),
//   },
//   button: {
//     minWidth: 100,
//   },
// }));

const ResultsFilter = ({ setfilterParams = () => {}, filterParams = {} }) => {
  const [anchorEl, setanchorEl] = React.useState(null);

  const { adminaxiosinstance } = useAdminAxios();
  const handleSubmit = (values) => {
    setfilterParams(values);
    setTimeout(() => {
      setanchorEl(null);
    });
  };

  const handleClear = () => {
    setfilterParams({});
  };

  return (
    <ClickAwayListener onClickAway={() => setanchorEl(null)}>
      <div>
        <Button
          onClick={(event) =>
            setanchorEl((current) => (current ? null : event.currentTarget))
          }
        >
          Filter
        </Button>
        <Popper
          open={Boolean(anchorEl)}
          anchorEl={anchorEl}
          placement="bottom-start"
          style={{ zIndex: 1001 }}
        >
          <Block paper style={{ padding: 15 }}>
            <Form
              initialValues={filterParams}
              onSubmit={handleSubmit}
              render={({ handleSubmit }) => (
                <Block>
                  <Field
                    tag="Person with disability"
                    type="text"
                    name="PWD"
                    component={CheckBox}
                    height={20}
                  />
                  <Field
                    tag="Student"
                    type="text"
                    name="Student"
                    component={CheckBox}
                    height={20}
                  />

                  <Field
                    name="Category"
                    component={RemoteSelector}
                    label="Entry Category"
                    axiosinstance={adminaxiosinstance}
                    url="/website/entrycategory/filtersearch"
                    labelExtractor={(row) => (row || {}).CategoryName || ''}
                    valueExtractor={(row) =>
                      row
                        ? {
                            CategoryName: row.CategoryName,
                            id: row.id,
                            CategoryCode: row.CategoryCode,
                          }
                        : row
                    }
                    keyExtractor={(row) => row.id}
                  />

                  <Field
                    label="Minimum Score"
                    type="number"
                    fullWidth
                    name="MinScore"
                    component={Input}
                  />

                  <Field
                    label="Maximum Score"
                    type="number"
                    fullWidth
                    name="MaxScore"
                    component={Input}
                  />

                  <Divider />

                  <Block row style={{ justifyContent: 'space-between' }}>
                    <Button outlined onClick={handleClear}>
                      Clear
                    </Button>
                    <Button contained primary onClick={handleSubmit}>
                      Filter
                    </Button>
                  </Block>
                </Block>
              )}
            />
          </Block>
        </Popper>
      </div>
    </ClickAwayListener>
  );
};

export default ResultsFilter;
